import { ArrowLeftIcon } from '@chakra-ui/icons';
import { AspectRatio, Badge, Box, Button, Center, Container, Flex, Heading, HStack, SimpleGrid, Spacer, Spinner, Stack, Text } from '@chakra-ui/react'
import { arrayUnion, doc, getDoc, setDoc } from 'firebase/firestore';
import React, { useContext, useEffect, useState } from 'react'
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import { db } from '../Config/firebase';

import AuthContext from '../Routes/hooks/AuthContext';

function ProductSinglePage() {
	const [product, setProduct] = useState()
	const param = useParams()
	const navigate=useNavigate()

	const { currentUser,notify} = useContext(AuthContext)

	const getProduct = async () => {
		try {
			const docRef = doc(db, "course",param.id);
			const docSnap = await getDoc(docRef);

			if (docSnap.exists()) {
			// console.log("Document data:", docSnap.data());
			setProduct(docSnap.data())

			} else {
			// doc.data() will be undefined in this case
			console.log("No such document!");
			}
		} catch (error) {
			console.log(error.message)
		}
	}

	const getYoutubeID = (data) => {
		const id = data.split('/')
		return `https://www.youtube.com/embed/${id[id.length - 1]}`
	}

	const handleBuy = async ()=>{
		//check if user loggedin ?
		console.log(currentUser,'this is the current user')
		if(currentUser){
			await setDoc(doc(db, "cart", currentUser.uid), 
			{products:arrayUnion({id:param.id,name:product.nama,price:product.price,image:product.thumbnail,qty:1})},
			{ merge: true })
			notify('Keranjang','Berhasil menambahkan produk ke keranjang kamu','success')

		}
		else{
			notify('Daftar / Login','Kamu harus mendaftarkan diri untuk membeli produk ini','warning')
			navigate('/login',{replace:true})
		}
	}

	useEffect(() => {
		getProduct()

		return () => {
		}
	}, [])

	return (
		<>
			<HStack>
				<Link to='/product'><ArrowLeftIcon /></Link>
				<Spacer />
				{product ? <Heading>{product.nama}</Heading> : <></>}
			</HStack>
			<HStack m='1'>
				{product ? product.tags.map((x, i) => <Badge key={i} bgColor='red' color='white'>{x}</Badge>) : <></>}
			</HStack>

			<AspectRatio width='100%' ratio={16 / 9} mb='1'>
				<iframe
					title='naruto'
					src='https://www.youtube.com/embed/QhBnZ6NPOY0'
					allowFullScreen
				/>
			</AspectRatio>
			<Container>
			<Button colorScheme='blue' width='full' p='2' onClick={()=>handleBuy()}>Beli</Button>
			</Container>
			<SimpleGrid columns={2} gap='1' mt='2'>
				{product ? product.youtube_link.map((x,i) =>
					<Stack key={i}>
						<AspectRatio width='100%' ratio={16 / 9}>
							<iframe
								title='naruto'
								src={getYoutubeID(x)}
								allowFullScreen
							/>
						</AspectRatio>
					</Stack>)
					:
					<></>}
			</SimpleGrid>

		</>
	)
}

export default ProductSinglePage